import React from 'react'

import { Carat, isUppercase } from '@syconium/little-miss-figgy'

import { NextLink } from '../../../app/_components/navigation/NextLink'
import { NavTile as Props } from '../../../types/graphql/site-fixtures'

import { Body, Figcaption, ResponsiveImage } from './styles'

export const NavTile: React.FC<Props> = ({ ctaText, href, image }) => {
  return (
    <NextLink href={href}>
      <Body>
        <ResponsiveImage
          alt={ctaText}
          loading='lazy'
          src={image}
          widths={{
            unit: 'px',
            sm: 256,
            md: 256,
          }}
          aspectRatios={{
            sm: 2 / 1,
            md: 2 / 1,
          }}
        />
        <Figcaption isUppercase={isUppercase(ctaText)}>
          {ctaText}
          <Carat />
        </Figcaption>
      </Body>
    </NextLink>
  )
}
